import ListBanks from './views/List.vue'
import CreateEditBank from './views/CreateEdit.vue'
import GetBank from './views/Get.vue'

export const BanksRoutes = [
  {
    path: '/banks',
    name: 'ListBanks',
    component: ListBanks,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'bank:list'
    }
  },
  {
    path: '/bank',
    name: 'CreateBank',
    component: CreateEditBank,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'bank:create'
    }
  },
  {
    path: '/bank/:id',
    name: 'UpdateBank',
    component: CreateEditBank,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'bank:update'
    }
  },
  {
    path: '/bank/view/:id',
    name: 'GetBank',
    component: GetBank,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'bank:get'
    }
  }
]
